import React from 'react'
import { contact } from '../../../content/site'

// Mailto block, on the new design system (Task 10). Copy is verbatim from the old
// src/pages/public/contact/email.jsx (git 06da2a1) - not one word changed, and the
// destination (mailto:info@nvisiondental.com, unchanged) and the `window.open` call it used
// are both kept as-is. Rebuilt on FinalCta's existing .cta-box/.cta-actions/.btn-lg
// primitives (no h2/eyebrow here, since the old block had neither) rather than inventing a
// parallel style - no new CSS needed for this component.
//
// Task 10 fix round 1: no longer wraps itself in its own <section className="section">/
// <div className="container"> - form.jsx now nests this directly under the form inside
// .contact-form-col, so the outer section/container (page-level vertical rhythm + max-width,
// meant for a standalone full-bleed block) would double up with the grid column it now lives
// in. The .cta-box itself is unchanged; only the wrapper it used to carry is gone.
const Email = () => {
  return (
    <div className="cta-box contact-email-box">
      <p>{contact.email.paragraph}</p>
      <div className="cta-actions">
        <button
          type="button"
          className="btn-lg"
          onClick={() => { window.open("mailto:info@nvisiondental.com") }}
        >
          {contact.email.cta}
        </button>
      </div>
    </div>
  )
}

export default Email
